import { AU } from './audio';
import { advanceCalib, calibrateAim, recalibrate } from './face';
import { toast } from './hud';
import { restart, togglePause } from './modes';
import { musicNext } from './music';
import { applySettings, syncSettingsUI } from './settings';
import { hammer } from './specials';
import { S, keys, save } from './state';
import { $ } from './util';

export const input = { spaceHeld: false };
const typing = (e: KeyboardEvent) => { const t = e.target as HTMLElement | null; return !!t && (t.tagName === 'INPUT' || t.tagName === 'TEXTAREA' || t.tagName === 'SELECT' || t.isContentEditable); };
addEventListener('keydown', e => {
  if (typing(e)){ if (e.key === 'Escape') (e.target as HTMLElement).blur(); return; }   // typing a name or an address: no hotkeys, no walking
  keys[e.code] = true;
  if (e.code==='Space'){ input.spaceHeld = true; e.preventDefault(); if (S.calRun || S.phase==='loading') advanceCalib(); }
  if (e.code==='Backquote'){ S.debug = !S.debug; $('#debugpanel').classList.toggle('on', S.debug); }
  if ((e.key==='c' || e.key==='C') && S.phase==='play') calibrateAim();
  if ((e.key==='g' || e.key==='G') && S.phase==='play') recalibrate();
  if ((e.key==='i' || e.key==='I') && S.lum.model){ const m = S.lum.model; S.lum.model = {on:m.off, off:m.on, w:m.w}; S.lum.scoreS = -S.lum.scoreS; toast('Lens read inverted'); }
  if (e.key==='m' || e.key==='M'){ save.settings.sound = !save.settings.sound; applySettings(); syncSettingsUI(); toast(save.settings.sound ? 'Sound on' : 'Muted'); }
  if (e.key==='Escape'){ if (S.phase==='play' && !S.calRun) togglePause(); else if (S.phase==='menu'){ for (const p of ['#how','#settings','#lb']) $(p).classList.add('hide'); } }
  if ((e.key==='r' || e.key==='R') && S.phase==='end') restart();
  if ((e.key==='n' || e.key==='N') && AU.ctx) musicNext();
  if (S.phase==='play' && !S.paused && e.key==='1') hammer();
});
addEventListener('keyup', e => { keys[e.code] = false; if (e.code==='Space') input.spaceHeld = false; });
addEventListener('mousemove', e => { if (S.keyboard){ S.aimRaw.x = e.clientX/innerWidth; S.aimRaw.y = e.clientY/innerHeight; } });
addEventListener('blur', () => { for (const k in keys) keys[k] = false; input.spaceHeld = false; });

